export default class MakeAcl {
  constructor(roles = []) {
    this.roles = roles;
  }

  addRole(role) {
    const index = this.findIndex(role);
    if (index === -1) {
      this.roles.push(role);
    }
  }

  setRoles(roles) {
    this.roles = roles;
  }

  removeRole(role) {
    const index = this.findIndex(role);
    if (index !== -1) {
      this.roles.slice(index, 1);
    }
  }

  findIndex(role) {
    const index = this.roles.indexOf(role);
    return index;
  }

  can(role) {
    if (role === undefined) {
      return false;
    }

    let isCan = false;
    const splitrole = role.split('|');
    for (let i = 0, len = splitrole.length; i < len; i += 1) {
      if (this.findIndex(splitrole[i]) !== -1) {
        isCan = true;
        break;
      }
    }
    return isCan;
  }

  canAnd(role) {
    if (role === undefined) {
      return false;
    }

    let isCan = false;
    const splitrole = role.split('|');
    for (let i = 0, len = splitrole.length; i < len; i += 1) {
      if (this.findIndex(splitrole[i]) !== -1) {
        isCan = true;
      } else {
        isCan = false;
        break;
      }
    }
    return isCan;
  }
}
